
import { Button } from "react-bootstrap"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PegarProcesso } from "services/CallAPIs"
import { docValido } from "services/TaxasCTM24/CalcularTaxaServico/GerarDocumento"
import * as Links from "constants/links"



export const DocGeradoComSucessoScreen = () =>
{
    const navigate = useNavigate()
    const location = useLocation()
    const [processo, setProcesso] = useState(false)
    const { tipoDoc, subTipoDoc, numProc, anoProc } = location.state
    
    useEffect(() => {
        async function fetchProcesso(numProc, anoProc)
        {
            setProcesso(await PegarProcesso(numProc, anoProc))
        }
        if (numProc && anoProc)
        {
            fetchProcesso(numProc, anoProc)
        }
    }, [numProc, anoProc])

    if (!docValido(tipoDoc, subTipoDoc)) { console.log("Erro: Página documento gerado com sucesso alcançada com doc inválido") ; return }
    if (!numProc || !anoProc) { console.log("Erro: Página documento gerado com sucesso alcançada sem dados do processo") ; return }
    
    function RedirectVerProcesso(processo)
    {    
        const state = {docData: undefined, procData: processo, statePrevPage: undefined, linkPrevPage: Links.VER_PROCESSO}
        navigate(Links.VER_PROCESSO, {state: state})
    }

    return (
        <div className="d-flex flex-column container bg-white border border-dark rounded-5 flex-grow-1 py-3 mb-3 shadow justify-content-center">
            <div className="d-flex flex-column align-items-center">
                <h4>Seu documento foi gerado com {<span className="text-success">sucesso!</span>}</h4>
                <h6>Caso queira corrigir algo, {<Button className="btn px-0 pt-0" onClick={() => {RedirectVerProcesso(processo)}} variant="link" >clique aqui</Button>} para editar</h6>
            </div>
        </div>
    )
}